import React, { useState, useEffect } from "react";
import { Formik, Field, Form } from "formik";
import {
  InputGroup,
  Label,
  SubmitBtn,
  SideCancelBtn,
  Wrapper,
  ScrollableContent,
  ActionSection,
  FieldWrappers,
} from "../../Styles/InputStyles";
import { MdClose } from "react-icons/md";
import tw from "tailwind-styled-components";
import * as Yup from "yup";
import "react-datepicker/dist/react-datepicker.css";
import Dropzone from "../../Properties/Details/Dropzone";
import { FormControl } from "@mui/material";
import MenuItem from "@mui/material/MenuItem"
import Select from "@mui/material/Select"
import { useLocation } from "react-router-dom";
import Config from "../../../Config";

const PG_OPTIONS = [
  { value: "Bathroom", label: "Bathroom" },
  { value: "Bedarea", label: "Bed Area" },
  { value: "Commonarea", label: "Common Area" },
  { value: "Kitchen", label: "Kitchen" },
  { value: "Other", label: "Other" },
];

const OFFICE_OPTIONS = [
  { value: "Reception", label: "Reception" },
  { value: "Cabin", label: "Cabin" },
  { value: "Workstation", label: "Workstation" },
  { value: "Conference Room", label: "Conference Room" },
  { value: "Pantry", label: "Pantry" },
  { value: "Other", label: "Other" },
];

const SHOWROOM_OPTIONS = [
  { value: "Front View", label: "Front View" },
  { value: "Inside View", label: "Inside View" },
  { value: "Display Area", label: "Display Area" },
  { value: "Counter", label: "Counter" },
  { value: "Storage", label: "Storage" },
  { value: "Other", label: "Other" },
];

const BHK_CONFIG = {
  "1": { bedroom: 1, kitchen: 1, bathroom: 1 },
  "2": { bedroom: 1, kitchen: 0, bathroom: 1 },

  "3": { bedroom: 1, kitchen: 1, bathroom: 1 },
  "4": { bedroom: 1, kitchen: 1, bathroom: 1, smallRoom: 1 },

  "5": { bedroom: 2, kitchen: 1, bathroom: 2 },
  "6": { bedroom: 2, kitchen: 1, bathroom: 2, smallRoom: 1 },

  "7": { bedroom: 3, kitchen: 1, bathroom: 3 },
  "8": { bedroom: 3, kitchen: 1, bathroom: 3, smallRoom: 1 },

  "9": { bedroom: 4, kitchen: 1, bathroom: 4 },
  "10": { bedroom: 4, kitchen: 1, bathroom: 4, smallRoom: 1 },

  "11": { bedroom: 5, kitchen: 1, bathroom: 5 },
  "12": { bedroom: 6, kitchen: 1, bathroom: 6 },
  "13": { bedroom: 7, kitchen: 1, bathroom: 7 },
  "14": { bedroom: 8, kitchen: 1, bathroom: 8 },
  "15": { bedroom: 9, kitchen: 1, bathroom: 9 },
};

const documentSchema = Yup.object().shape({
  imageType: Yup.string().required("Image type is required"),

  customTitle: Yup.string().when("imageType", {
    is: "Other",
    then: () => Yup.string()
      .required("Custom title is required")
      .min(3, "Must be at least 3 characters"),
  }),

  files: Yup.array()
    .min(1, "At least one image is required")
    .required("Images are required"),
});

const ImageUploadModal = ({
  setImageUpload,
  uploadImageMutate,
  isImageLoading,
  // propId,
  apiData,
  bhk,
  inventoryType, inventoryId,
}) => {
  const initialDocumentValues = {
    imageType: "",
    customTitle: "",
    files: [],
  };

  const [height, setHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleResize = () => {
      setHeight(window.innerHeight);
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
 

  const handleDocumentSubmit = (values) => {
    const formData = new FormData();

    formData.append("inventoryId", inventoryId);

    const title =
      values.imageType === "Other"
        ? values.customTitle
        : values.imageType;

    formData.append("title", title);

    values.files.forEach((file) => {
      formData.append("files", file);
    });

    uploadImageMutate(formData);
  };

  const getImageOptions = () => {

    if (inventoryType === Config.LANDLORD_PROPERTY_TYPE.PG) {
      return PG_OPTIONS;
    }

    if (inventoryType === Config.LANDLORD_PROPERTY_TYPE.SHOP_SHOWROOM) {
      return OFFICE_OPTIONS;
    }

    if (inventoryType === Config.LANDLORD_PROPERTY_TYPE.OFFICE) {
      return SHOWROOM_OPTIONS;
    }

    if (!bhk) return [];

    const config = BHK_CONFIG[bhk];

    if (!config) return [];

    const options = [];

    for (let i = 1; i <= config.bedroom; i++) {
      options.push({
        value: `Bedroom ${i}`,
        label: `Bedroom ${i}`,
      });
    }

    if (config.smallRoom) {
      options.push({
        value: "Small Room",
        label: "Small Room",
      });
    }

    for (let i = 1; i <= config.bathroom; i++) {
      options.push({
        value: `Bathroom ${i}`,
        label: `Bathroom ${i}`,
      });
    }

    for (let i = 1; i <= config.kitchen; i++) {
      options.push({
        value: `Kitchen ${i}`,
        label: `Kitchen ${i}`,
      });
    }

    options.push({ value: "Other", label: "Other" });

    return options;
  };
  return (
    <Container
      style={{
        height: `${height}px`,
        overflow: "auto",
        WebkitOverflowScrolling: "touch",
      }}
    >
      <Header>
        <Title>Upload Images</Title>
        <button onClick={() => setImageUpload(false)}>
          <MdClose color="white" size={24} />
        </button>
      </Header>

      <div className="px-6 h-full flex flex-col justify-between">
        <Formik
          initialValues={initialDocumentValues}
          onSubmit={handleDocumentSubmit}
          validationSchema={documentSchema}
        >
          {({ values, setFieldValue, errors, touched }) => (
            <Form>
              <ScrollableContent className="max-h-[calc(100dvh-140px)]">
                <Wrapper>
                  {/* Title Field */}
                  <InputGroup>
                    <Label>Image Title</Label>

                    <Select
                      className="px-2"
                      name="imageType"
                      value={values.imageType}
                      onChange={(e) => setFieldValue("imageType", e.target.value)}
                      displayEmpty
                      style={{ height: "46px" }}
                      renderValue={(selected) => {
                        if (!selected) {
                          return (
                            <span style={{ color: "#9ca3af" }}>
                              Select Image Type
                            </span>
                          );
                        }

                        const option = getImageOptions().find((o) => o.value === selected);
                        return option ? option.label : selected;
                      }}
                    >
                      <MenuItem value="" disabled>
                        Select Image Type
                      </MenuItem>

                      {getImageOptions().map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                          {option.label}
                        </MenuItem>
                      ))}
                    </Select>

                    {errors.imageType && touched.imageType && (
                      <ErrorMessage>{errors.imageType}</ErrorMessage>
                    )}
                  </InputGroup>

                  {values.imageType === "Other" && (
                    <InputGroup>
                      <Label>Enter Image Title</Label>
                      <FieldWrappers>
                        <Field
                          type="text"
                          name="customTitle"
                          placeholder="Enter custom image title"
                        />
                      </FieldWrappers>

                      {errors.customTitle && touched.customTitle && (
                        <ErrorMessage>{errors.customTitle}</ErrorMessage>
                      )}
                    </InputGroup>
                  )}

                  {/* Multiple Image Upload */}
                  <InputGroup>
                    <Label htmlFor="files">Upload Images *</Label>

                    <Field name="files">
                      {({ field, form }) => (
                        <Dropzone
                          setFieldValue={form.setFieldValue}
                          File={field.value}
                        />
                      )}
                    </Field>

                    {errors.files && touched.files && (
                      <ErrorMessage>{errors.files}</ErrorMessage>
                    )}
                  </InputGroup>
                </Wrapper>
              </ScrollableContent>

              <ActionSection>
                <SideCancelBtn
                  type="button"
                  onClick={() => setImageUpload(false)}
                >
                  Cancel
                </SideCancelBtn>

                <SubmitBtn type="submit" disabled={isImageLoading}>
                  {isImageLoading ? "Uploading..." : "Upload"}
                </SubmitBtn>
              </ActionSection>
            </Form>
          )}
        </Formik>
      </div>
    </Container>
  );
};


const Header = tw.div`flex items-center justify-between bg-gradient-to-r from-primary-color to-teal-400 py-4 px-4`;
const Container = tw.div`bg-white w-full h-full min-h-[100vh] flex flex-col`;
const Title = tw.h1`text-lg md:text-xl font-medium text-center text-white`;
const ErrorMessage = tw.div`text-red-500 text-xs mt-1`;
const FieldWrapper = tw.div`w-full`;

export default ImageUploadModal;